const CODE128_PATTERNS = [
  '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212', '221213',
  '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221', '223211', '221132',
  '221231', '213212', '223112', '312131', '311222', '321122', '321221', '312212', '322112', '322211',
  '212123', '212321', '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313',
  '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121', '313121', '211331',
  '231131', '213113', '213311', '213131', '311123', '311321', '331121', '312113', '312311', '332111',
  '314111', '221411', '431111', '111224', '111422', '121124', '121421', '141122', '141221', '112214',
  '112412', '122114', '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111',
  '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141',
  '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311', '113141',
  '114131', '311141', '411131', '211412', '211214', '211232', '2331112',
];

const START_B = 104;
const STOP = 106;
const QUIET_ZONE_MODULES = 10;
const MODULE_WIDTH = 2;
const BARCODE_HEIGHT = 72;

const escapeHtml = (value: string): string => value
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

export const normalizeCode128Value = (value: string): string => String(value || '')
  .trim()
  .split('')
  .map((character) => {
    const code = character.charCodeAt(0);

    return code >= 32 && code <= 126 ? character : '-';
  })
  .join('');

/**
 * Produit le SVG injecté par v-html dans les tickets et les étiquettes.
 * Les barres utilisent des coordonnées numériques ; la valeur textuelle doit
 * rester échappée dans aria-label pour ne pas devenir du balisage exécutable.
 */
export const code128Svg = (rawValue: string): string => {
  const value = normalizeCode128Value(rawValue);

  if (!value) {
    return '';
  }

  const encoded = value.split('').map((character) => character.charCodeAt(0) - 32);
  const checksum = encoded.reduce(
    (total, code, index) => total + code * (index + 1),
    START_B,
  ) % 103;
  const sequence = [START_B, ...encoded, checksum, STOP];
  const modules = sequence
    .map((code) => CODE128_PATTERNS[code])
    .join('')
    .split('')
    .reduce((total, digit) => total + Number(digit), QUIET_ZONE_MODULES * 2);
  const width = modules * MODULE_WIDTH;
  let cursor = QUIET_ZONE_MODULES * MODULE_WIDTH;
  const rects: string[] = [];

  sequence.forEach((code) => {
    const pattern = CODE128_PATTERNS[code];
    let drawBar = true;

    pattern.split('').forEach((digit) => {
      const barWidth = Number(digit) * MODULE_WIDTH;

      if (drawBar) {
        rects.push(`<rect x="${cursor}" y="0" width="${barWidth}" height="${BARCODE_HEIGHT}" />`);
      }

      cursor += barWidth;
      drawBar = !drawBar;
    });
  });

  return [
    `<svg class="code128-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${BARCODE_HEIGHT}" role="img" aria-label="Code-barres ${escapeHtml(value)}">`,
    '<rect width="100%" height="100%" fill="#fff" />',
    `<g fill="#111827">${rects.join('')}</g>`,
    '</svg>',
  ].join('');
};
